



































import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import NewVoteButton from '../components/VoteButtonNew.vue';
import { Icon, Toast } from 'vant';
import { caseDetail } from '../api';
import qs from 'qs';
import { vote } from '@/api/api';

Vue.use(Icon);
@Component({
  components: {
    NewVoteButton,
  },
})
export default class CaseDetail extends Vue {
  voteName: string = '2023project/q4/2024economics_case_vote';
  shareTitle: string = '';
  shareSubtitle: string = '';
  shareCover: string = '';
  timeSecond: number = 10;
  item: any = {};
  showTimeDown: boolean = true;
  unionId!: string | null;
  voteEnable = true;
  pointOut = false;
  throttleTimer: any = null;

  async activated() {
    const res: any = await caseDetail(this.$route.query.id as string);
    this.item = res.data;
    this.shareTitle = this.item.name;
    this.shareSubtitle = this.item.recommend;
    this.onRouteChange(res.data);
    this.timechange();
  }

  timechange() {
    let timeid = setTimeout(() => {
      this.timeSecond--;
      if (this.timeSecond > 0) {
        if (this.$route.path.indexOf('caseDetail') < 0) {
          clearTimeout(timeid);
        } else {
          clearTimeout(timeid);
          this.timechange();
        }
      } else {
        this.showTimeDown = false;
        this.recodeOnVote();
      }
    }, 1000);
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  async recodeOnVote() {
    // DONE 大量代码需重构
    // 微信环境中引导用户登录(若需要)
    this.unionId = window.localStorage.getItem('unionid');
    if (!isWeiXin() && !window.udid) {
      // Toast.showModel({
      //   duration: 3000,
      //   message: '若需要使用投票功能！请在微信或者上游APP打开',
      // });
      Toast({
        type: 'fail',
        duration: 5000,
        message: '若需要使用投票功能！请在微信或者上游APP打开',
      });
      return;
    } else if (!this.unionId && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
    // 开始投票，微信环境和App环境传递参数有所不同
    let apiData: any = {};
    if (isWeiXin()) {
      this.unionId = window.localStorage.getItem('unionid');
      apiData = {
        id: this.item.id,
        unionid: this.unionId,
        source: 0,
      };
    } else if (window.udid) {
      apiData = {
        id: this.item.id,
        udid: window.udid,
        appkey: window.appkey,
        source: 0,
      };
    } else {
      this.$dialog
        .confirm({
          title: '友情提示',
          message: '请在上游新闻App进行投票',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
        .then((action) => {
          console.log(action);
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch((action) => {
          console.log(action);
          if (action === 'overlay') {
            // 忽略掉点击遮罩层的关闭行为
            return;
          }
          if (isWeiXin()) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
      return;
    }
    // if (this.voteWeChat && isWeiXin()) {
    //   this.unionId = window.localStorage.getItem('unionid');
    //   apiData = {
    //     id: this.voteId,
    //     unionid: this.unionId,
    //     source: this.source,
    //   };
    // } else {
    //   return Toast('请在微信里投票');
    // }
    // 节流
    if (!this.voteEnable) {
      return Toast('手速不要太快哦');
    }
    this.voteEnable = false;
    clearTimeout(this.throttleTimer);
    this.throttleTimer = setTimeout(() => {
      this.voteEnable = true;
    }, 3000);

    const result = await vote(this.voteName, apiData);
    this.successVote1(result);
  }
  successVote1(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });

        this.votSuccess(res.data, -1);
        break;
      case 201:
        break;
      case 202:
        if (parseFloat(window.version) >= 4.5) {
          // 需要在App内登录
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          // 老版本唤起App登录页面栈
          window.location.href = 'client:logout';
        }
        break;
      case 203:
        // 超出投票规定次数
        if (isWeiXin()) {
          Toast.fail('今日投票数已用完，请明天再试！');
        } else {
          Toast.fail(res.msg);
        }
        break;
      case 505:
        localStorage.removeItem('unionid');
        window.location.reload();
        break;
      case 500:
      case 204:
      case 300:
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
  onRouteChange(data: any) {
    console.log(this.shareTitle); // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: this.shareTitle,
      url: location.href,
      subtitle: '',
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: this.shareTitle,
        subtitle: '',
        image: cover,
      });
    }
  }
  votSuccess(data: any, index: any) {
    this.item.votes = data;
    this.$emit('like');
  }
}
